import React, { useState } from "react";
import easaImage from "../img/easa.png";
import portalImage from "../img/01-overview-portal.png";
import { Container, Row, Col, Image, Card, CardGroup } from "react-bootstrap";

export const Banner = () => {
  return (
    <section className="custom-section">
      <Container fluid style={{ maxWidth: "1200px" }}>
        <Row>
          <Col md={12}>
            <div
              className="text-center my-2 mx-auto"
              style={{ maxWidth: "850px" }}
            >
              <h2 style={{ fontSize: "40px" }}>
                <b>{`Discover Your Exposure Now`}</b>
              </h2>
            </div>
          </Col>
          <CardGroup className="p-3">
            <Card
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "#ffffff",
              }}
            >
              <Image
                className="my-4 shadow-sm"
                src={easaImage}
                alt="External Attack Surface Assessment"
                width={550}
                height={"100%"}
                fetchpriority="high"
                decoding="async"
                fluid
              />
              <Card.Footer
                className="border-0"
                style={{ marginTop: "auto", backgroundColor: "#ffffff" }}
              >
                <Card.Text className={"open-sans lead mt-auto"}>
                  {`Unveil what `}
                  <span className="fw-bold">{`adversaries`}</span>
                  {` know about your organization with Lumu's External Attack Surface Assessment.`}
                </Card.Text>
                <a
                  href="https://lumu.io/discover/#get-free-assessment"
                  className="custom-btn d-block montserrat text-decoration-none py-2 my-3"
                  role="button"
                  target="_blank"
                >
                  {`Get a Free Assessment Now`}
                </a>
              </Card.Footer>
            </Card>
            <Card style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Image
                className="my-3 shadow-sm"
                src={portalImage}
                alt="External Attack Surface Assessment"
                width={500}
                height={"100%"}
                fetchpriority="high"
                decoding="async"
                fluid
              />
              <Card.Footer
                className="border-0 bg-white"
                style={{ marginTop: "auto" }}
              >
                <Card.Text className={"open-sans lead"}>
                  {`Measure your exposure to `}
                  <span className="fw-bold">{`ransomware`}</span>
                  {` by opening your Lumu Account.`}
                </Card.Text>
                <a
                  href="https://portal.lumu.io/account/sign-up"
                  className="custom-btn-dark d-block montserrat fw-bold text-decoration-none py-2 text-center my-3"
                  role="button"
                  target="_blank"
                >
                  {`Get Lumu Free Now`}
                </a>
              </Card.Footer>
            </Card>
          </CardGroup>
        </Row>
      </Container>
    </section>
  );
};
